import { error } from 'ajv/dist/vocabularies/applicator/dependencies';
import {
  INIT_MACHINE_LIST_REQUEST,
  SET_MACHINE_LIST,
  ERROR_MACHINE_LIST,
  ADD_MACHINE,
  SET_MACHINE,
  UPDATE_MACHINE,
  ERROR_MACHINE,
  DELETE_MACHINE,
  SET_MACHINE_LIST_BY_COMPANY_ID
} from './action';

const initialState = {
  data: [],
  machineListDataCompanyId:[],
  error: null,
  isLoading: false,
  selectedMachine: null,
};

const machineListReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_MACHINE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SET_MACHINE_LIST:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
      };
    case SET_MACHINE_LIST_BY_COMPANY_ID:
      return{
        ...state,
        machineListDataCompanyId:action.payload,
        isLoading:false,
        error:null
      }
    case ERROR_MACHINE_LIST:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ERROR_MACHINE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ADD_MACHINE:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case UPDATE_MACHINE:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case SET_MACHINE:
      return {
        ...state,
        isLoading: false,
        selectedMachine: action.payload,
        error: null,
      };
      case DELETE_MACHINE:
        return {
          ...state,
          isLoading: false,
          error: null,
        };
    default:
      return state;
  }
};

export default machineListReducer;
